// @flow
import React from "react";
import PropTypes from "prop-types";
import {useHistory} from "react-router";

const AdminButton = ({adminClicked, doDefaultAction=false}) => {
    
    const history = useHistory();
    
    function preAdminClicked() {
        if(doDefaultAction) {
            handleDefaultAdmin();
        } else {
            if(adminClicked) {
                adminClicked();
            }
        }
    }
    
    function handleDefaultAdmin() {
        const redirectTo={ 'pathname': '/adminPage', 'search': "", 'state': {'from': '/adminPage', 'to': '/adminPage'}};
        history.replace(redirectTo);  // force go there NOW.  changed 260325 -pott
        //setRedirectToPage("/adminPage");
    }
    
    return <span className="fa-stack fa-1_5x li-pointer mt-1 li-admin-button" data-toggle="tooltip" title="admin" onClick={preAdminClicked}>
              <i className="li-fg-danger fa fa-circle fa-stack-2x"></i>
              <i className="fa fa-cog fa-stack-1x li-fg-white"></i>
            </span>;

    //return <LIButton secondary faIcon="fas fa-cog" tooltip="admin system" bgClass="" onClick={preAdminClicked}/>
}

AdminButton.propTypes =  {
    adminClicked: PropTypes.func,
    doDefaultAction: PropTypes.bool
}

export default AdminButton;